import { defaultData, setServiceData } from "../service";
export const Service = 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(data) => (target) => {
    setServiceData(target, {
        ...defaultData,
        ...(data || {}),
    });
};
